<app-page-container id="app-page-container" style="overflow-y: hidden">
  <div class="search-page-container">
    <div class="search-page-top-container" id="search-page-top-container">
      <div class="search-filter-container">
        <app-autocompletebox-osm
          class="ac-box"
          [placeholder]="'zipCityStreet' | translate"
          [value]="formData.meinStandort"
          [centerLat]="addressLat"
          [centerLng]="addressLon"
          (onSelected)="onSelected($event)"
        >
        </app-autocompletebox-osm>

        <dx-button
          type="default"
          [icon]="extSearchHidden ? 'chevrondown' : 'chevronup'"
          [text]="' ' + ('extendedSearch' | translate)"
          (onClick)="onClickKindExtSearch()"
          class="ext-search-button"
          [rtlEnabled]="true"
        >
        </dx-button>

        <dx-button
          type="default"
          icon="tableproperties"
          [text]="' ' + ('inquireChild' | translate)"
          (onClick)="onClickKindAnmelden()"
          class="anmelde-button"
        >
        </dx-button>
      </div>
      <span *ngIf="extSearchHidden" class="extended-search-title">
        {{ filterText.length > 0 ? ('applied_filter' | translate) : '' }}&nbsp;
        <b class="filter-text" (click)="onClickKindExtSearch()">{{ filterText }}</b>
      </span>
    </div>

    <div class="search-page-result-container" id="search-page-result-container">
      <!-- <div [hidden]="extSearchHidden" class="ext-search-container"> -->
      <div class="ext-search-container">
        <dx-form class="search-page-extended-search" #externSearchForm1 [formData]="formData" [colCount]="3">
          <dxi-item
            dataField="searchBetreuungsArt"
            editorType="dxSelectBox"
            [label]="{ text: 'careType' | translate }"
            [colSpan]="1"
            [editorOptions]="{
              tabIndex: 1,
              dataSource: configService.getKatalog('BetreuungsArtKatalog'),
              valueExpr: 'id',
              displayExpr: 'bezeichnung',
              searchMode: 'startswith',
              searchTimeout: 200,
              searchExpr: 'bezeichnung',
              onValueChanged: onBetreuungsArtValueChanged
            }"
          >
          </dxi-item>

          <dxi-item
            dataField="searchBetreuungsZeit"
            editorType="dxSelectBox"
            [label]="{ text: 'careTime' | translate }"
            [colSpan]="1"
            [editorOptions]="{
              tabIndex: 2,
              dataSource: betreuungsZeitDataSource,
              valueExpr: 'id',
              displayExpr: 'bezeichnung',
              searchMode: 'startswith',
              searchTimeout: 200,
              searchExpr: 'bezeichnung',
              onValueChanged: onFilterValueChanged
            }"
          >
          </dxi-item>

          <dxi-item
            dataField="traegerId"
            editorType="dxSelectBox"
            [label]="{ text: 'holder' | translate }"
            [colSpan]="1"
            [editorOptions]="{
              tabIndex: 3,
              dataSource: traeger,
              valueExpr: 'key',
              displayExpr: 'value',
              searchMode: 'startswith',
              searchTimeout: 200,
              searchExpr: 'value',
              onValueChanged: onFilterValueChanged
            }"
          >
          </dxi-item>

          <dxi-item
            dataField="einrichtungsName"
            [label]="{ text: 'institution' | translate }"
            [colSpan]="1"
            [editorOptions]="{
              tabIndex: 4,
              maxLength: 50,
              placeholder: 'textboxName' | translate,
              searchEnabled: true,
              searchMode: 'startswith',
              searchTimeout: 200,
              searchExpr: 'value',
              valueChangeEvent: 'keyup',
              onValueChanged: onFilterValueChanged
            }"
          >
          </dxi-item>

          <dxi-item>
            <div class="dx-field-label">{{ 'distance' | translate }}</div>
            <dx-slider [min]="1" [max]="50" [(value)]="mapSearchRadius" [rtlEnabled]="false" (onValueChanged)="onRangeSliderChanged($event)">
              <dxo-label [visible]="true" [format]="format" position="bottom"></dxo-label>
              <dxo-tooltip [enabled]="true" width="80" showMode="always" position="bottom" [format]="formatSearchRadius"></dxo-tooltip>
            </dx-slider>
          </dxi-item>
        </dx-form>
      </div>

      <div class="search-page-result-container-2">
        <div class="search-page-map-container">
          <div class="search-result-container">
            <span class="search-result-info" *ngIf="filteredResults.length === 1"
              >{{ filteredResults.length }} {{ 'foundInstitution' | translate }}</span
            >
            <span class="search-result-info" *ngIf="filteredResults.length !== 1"
              >{{ filteredResults.length }} {{ 'foundInstitutions' | translate }}</span
            >
          </div>

          <app-map-osm
            id="map"
            #map
            [centerImage]="marker_icon_center"
            [centerTitle]="'ownLocation' | translate"
            [centerPopupDetails]="'ownLocation' | translate"
            [centerLat]="addressLat"
            [centerLng]="addressLon"
            (dragEnd)="ondragEnd($event)"
          ></app-map-osm>
        </div>

        <div class="search-result-content">
          <div class="search-page-open-close-buttons">
            <dx-button
              class="search-result-item-container-content-toolbar-btn"
              type="default"
              [text]="isAccordeonOpen ? ('closeAll' | translate) : ('openAll' | translate)"
              [icon]="isAccordeonOpen ? 'chevrondoubleleft' : 'chevrondoubleright'"
              (onClick)="onOpenCloseClick()"
            >
            </dx-button>
          </div>

          <dx-accordion
            class="search-page-result-accordion"
            #resultAccordion
            [dataSource]="filteredResults"
            [selectedItems]="accordionSelectedItems"
            [collapsible]="true"
            [animationDuration]="500"
            [deferRendering]="true"
            [repaintChangesOnly]="false"
            [multiple]="true"
            (onItemTitleClick)="onItemTitleClick($event)"
            (onContentReady)="onContentReady($event)"
          >
            <div *dxTemplate="let item of 'title'">
              <div class="search-page-result-accordion-header-container">
                <div>
                  {{ item.einrichtungsName }},
                  <span class="einrichtung-adresse">{{ item.plz }} {{ item.ort }}, {{ item.strasse }} {{ item.hnr }}{{ item.hnrzusatz }} </span
                  ><span *ngIf="item.distance" style="color: grey">({{ item.distance }} km)</span>
                </div>
                <div>
                  <img *ngIf="getIsSelected(item.id) && isInit" [src]="getMarkerImageForHeader(item.id)" />
                </div>
              </div>
            </div>
            <div *dxTemplate="let item of 'item'">
              <div class="search-page-result-accordion-item-content">
                <div class="einrichtung-galerie" *ngIf="item.galerie.length > 0">
                  <div class="dx-fieldset wrapper" style="margin: 5px">
                    <div class="dx-fieldset" style="margin: 0">
                      <div class="dx-field search-gallery">
                        <dx-gallery
                          #gallery
                          id="gallery"
                          [dataSource]="item.galerie"
                          [height]="200"
                          [width]="300"
                          [loop]="true"
                          [showNavButtons]="true"
                          [wrapAround]="false"
                        ></dx-gallery>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="einrichtung-no-galerie" *ngIf="item.galerie.length == 0">
                  <div class="dx-fieldset wrapper" style="margin: 5px; width: 300px;">&nbsp;</div>
                </div>

                <div class="item-content-info">
                  <div class="item-content-info-container">
                    <div class="dx-fieldset wrapper">
                      <div class="dx-fieldset" style="margin: 10px 5px">
                        <div class="dx-field">
                          <span
                            ><b>{{ 'address' | translate }}:</b><br />{{ item.strasse }} {{ item.hnr }}{{ item.hnrzusatz }}<br />{{ item.plz }}
                            {{ item.ort }}</span
                          >
                        </div>
                      </div>
                      <div class="dx-fieldset" style="margin: 10px 5px">
                        <div class="dx-field">
                          <span
                            ><b>{{ 'holder' | translate }}:</b><br />{{ getTraeger(item.traegerId) }}</span
                          >
                        </div>
                        <div class="dx-field types-of-care">
                          <span
                            ><b>{{ 'careType' | translate }}:</b><br />
                            <span *ngFor="let arten of item.betreuungsarten; index as i">
                              {{ arten.value }} {{ i < item.betreuungsarten.length - 1 ? '-' : '' }}
                            </span>
                          </span>
                        </div>
                        <div class="dx-field homepage-1">
                          <span
                            ><b
                              ><a *ngIf="item.web !== null && item.web.length > 0" href="{{ item.web }}" target="_blank"
                                ><i style="color: #03a9f4" class="dx-icon-home"></i> {{ 'homepage' | translate }}</a
                              ></b
                            ></span
                          >
                        </div>
                      </div>
                    </div>

                    <div class="dx-fieldset wrapper einrichtung-oeffnung">
                      <div class="dx-fieldset" style="margin: 10px 5px">
                        <div class="dx-field" style="display: flex; flex-direction: column">
                          <span
                            ><b>{{ 'openingHours' | translate }}:<br /></b
                          ></span>
                          <div class="content-info-col3-uhrzeit">
                            <div class="content-info-col3-uhr1">
                              <span *ngFor="let data of wochentage; index as iTag">
                                <span class="content-info-col3-container">
                                  <span class="content-info-col3-content" [innerHtml]="data.value | translate"></span>
                                  <span class="content-info-col3-content" [innerHtml]="item.oeffnungszeiten[iTag].beginn"></span>
                                  <span class="content-info-col3-content-separator">-</span>
                                  <span class="content-info-col3-content" [innerHtml]="item.oeffnungszeiten[iTag].ende"></span>
                                  <span class="content-info-col3-content">&nbsp;{{ 'clockAM' | translate }}</span>
                                </span>

                                <span
                                  *ngIf="item.oeffnungszeiten[iTag].beginn2 !== null || item.oeffnungszeiten[iTag].ende2 !== null"
                                  class="content-info-col3-container"
                                >
                                  <span class="content-info-col3-content" [innerHtml]=""></span>
                                  <span class="content-info-col3-content" [innerHtml]="item.oeffnungszeiten[iTag].beginn2"></span>
                                  <span class="content-info-col3-content-separator">-</span>
                                  <span class="content-info-col3-content" [innerHtml]="item.oeffnungszeiten[iTag].ende2"></span>
                                  <span class="content-info-col3-content">&nbsp;{{ 'clockAM' | translate }}</span>
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="dx-field">
                          <span
                            ><b>{{ 'totalCapacity' | translate }}:</b><br />{{ item.platzanzahl }} {{ 'seats' | translate }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="dx-fieldset wrapper homepage-2">
                    <div class="dx-field">
                      <span
                        ><b>{{ 'homepage' | translate }}:</b><br /><a href="{{ item.web }}" target="_blank">{{ item.web }}</a></span
                      >
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: row; width: 100%; height: clac(100% - 158px)">
                    <div class="dx-fieldset" style="width: 50%; margin: 16px 21px">
                      <dx-button
                        class="search-result-item-container-content-toolbar-btn-details"
                        type="default"
                        icon="detailslayout"
                        (onClick)="onDetailsClick(item)"
                        [text]="'details' | translate"
                      >
                      </dx-button>
                    </div>
                    <div class="dx-fieldset select-btn" style="width: 50%; margin: 16px 21px">
                      <dx-button
                        *ngIf="item.isSelectable === true"
                        class="search-result-item-container-content-toolbar-btn"
                        type="default"
                        [text]="getIsSelected(item.id) ? ('deselect' | translate) : ('select' | translate)"
                        [icon]="getIsSelected(item.id) ? 'trash' : 'selectall'"
                        (onClick)="onSelectClick($event, item)"
                      >
                      </dx-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </dx-accordion>
        </div>
      </div>
    </div>
  </div>
  <div class="search-page-footer-container">
    <div class="dx-fieldset">
      <dx-button
        type="default"
        icon="tableproperties"
        [text]="' ' + ('inquireChild' | translate)"
        (onClick)="onClickKindAnmelden()"
        class="anmelde-button-2"
      >
      </dx-button>
    </div>
  </div>

  <!-- <div class="moving-container">
    Test
  </div> -->
</app-page-container>
